enum ProductIssueMigrationType {
    MigrateAll = "MIGRATE_ALL_ISSUES",
    MigrateCurrent = "MIGRATE_CURRENT_ISSUE",
    MigrateSpecific = "MIGRATE_SPECIFIC_ISSUE"
}
export default ProductIssueMigrationType